<template>
  <div class="legal wide-container">
    <h1 class="legal__title">
      <Lang by-key="legal-notice-title" />
    </h1>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-0-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-0-body-0" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-0-body-1" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-0-body-2" />
      </p>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-0-body-3" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-1-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-1-body-0" />
      </p>

      <div class="legal__block__table">
        <div class="cell-header">
          <Lang by-key="address" />:
        </div>
        <div class="cell">
          Avenida Sor Soledad Cobian, 3, 38300 - Orotava, La
        </div>

        <div class="cell-header">
          <Lang
            by-key="email"
            capitalize-all
          />:
        </div>
        <div class="cell">
          <a href="mailto:ayuda@spalopia.com">
            <SplButton variant="link">
              ayuda@spalopia.com
            </SplButton>
          </a>
        </div>

        <div class="cell-header">
          <Lang
            by-key="web-hosted-at"
            capitalize-first
          />:
        </div>
        <div class="cell">
          OVH
        </div>
      </div>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-2-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-2-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-2-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-2-body-2" />
      </p>

      <ul class="legal__block__list">
        <li><Lang by-key="legal-notice-2-body-3" /></li>
        <li><Lang by-key="legal-notice-2-body-4" /></li>
      </ul>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-3-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-3-body-0" />
      </p>
      <ul class="legal__block__list">
        <li><Lang by-key="legal-notice-3-body-1" /></li>
        <li><Lang by-key="legal-notice-3-body-2" /></li>
        <li><Lang by-key="legal-notice-3-body-3" /></li>
        <li><Lang by-key="legal-notice-3-body-4" /></li>
        <li><Lang by-key="legal-notice-3-body-5" /></li>
        <li><Lang by-key="legal-notice-3-body-6" /></li>
        <li><Lang by-key="legal-notice-3-body-7" /></li>
      </ul>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-4-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-4-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-5-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-5-body-0" />
        <SplNuxtLink
          is-external
          no-lang
          class="ml-text"
          to="/politica-de-privacidad/"
        >
          <SplButton variant="link">
            <Lang by-key="privacy-policy" />
          </SplButton>
        </SplNuxtLink>
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-6-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-6-body-0" />

        <SplNuxtLink
          is-external
          no-lang
          class="ml-text"
          to="/politica-de-cookies/"
        >
          <SplButton variant="link">
            <Lang by-key="cookies-policy" />
          </SplButton>
        </SplNuxtLink>
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-7-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-7-body-0" />
      </p>
      <ul class="legal__block__list">
        <li>
          <Lang by-key="legal-notice-7-body-1" />
          <span class="ml-text">Avenida Sor Soledad Cobian, 3, 38300 - Orotava, La</span>
        </li>
        <li>
          <Lang by-key="legal-notice-7-body-2" />
          <a
            class="ml-text"
            href="mailto:ayuda@spalopia.com"
          >
            <SplButton variant="link">
              ayuda@spalopia.com
            </SplButton>
          </a>
        </li>
      </ul>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-8-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-8-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-8-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-8-body-2" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-8-body-3" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-9-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-9-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-9-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-9-body-2" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-10-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-10-body-0" />
      </p>
    </div>

    <div class="legal__block">
      <h3 class="legal__block__header">
        <Lang by-key="legal-notice-11-header" />
      </h3>

      <p class="legal__block__body">
        <Lang by-key="legal-notice-11-body-0" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-11-body-1" />
      </p>
      <p class="legal__block__body">
        <Lang by-key="legal-notice-11-body-2" />
      </p>
    </div>

    <div class="legal__block">
      <p class="legal__block__body">
        <Lang
          capitalize-first
          by-key="version"
        />
        <span>: 2.0</span>
      </p>
      <p class="legal__block__body">
        <Lang
          capitalize-first
          by-key="date"
        />
        <span>: 24/05/18</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import SplNuxtLink from '~/core/components/shared/SplNuxtLink.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    SplNuxtLink,
    SplButton,
  },
  setup() {
    const builder = HeadMetaBuilder.create()
    builder.withTitleAndMetaTitle('Aviso Legal | Spalopia.com')

    useHead(builder.get())

    return {}
  }
})
</script>

<style lang="scss" scoped>
@import url('./legal.scss');
</style>
